//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
  name: 'BcCheckStatus',
  props: {
    checkType: {
      type: String,
      default () {
        return 'task'
      }
    },
    task: {
      type: Object,
      default () {
        return {}
      }
    },
    freelancer: {
      type: Object,
      default () {
        return {}
      }
    },
    client: {
      type: Object,
      default () {
        return {}
      }
    },
    feedback: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isOnBc: false
    }
  },
  computed: {
    isBcDataSet () {
      return this.$store.state.user.bcDataSet
    },

    isDarkMode () {
      return this.$store.state.ui.isDarkThemeEnabled
    },

    modalId () {
      return `blockchain-modal${Math.random()
        .toString(36)
        .substring(2, 15)}${Math.random()
        .toString(36)
        .substring(2, 15)}`
    }
  },
  watch: {
    task () {
      this.checkBc()
    },
    freelancer () {
      this.checkBc()
    },
    client () {
      this.checkBc()
    },
    feedback () {
      this.checkBc()
    },
    isBcDataSet () {
      this.checkBc()
    }
  },
  mounted () {
    this.checkBc()
  },
  methods: {
    async checkBc () {
      try {
        const bcData = this.$smartContract.getBcData()

        if (this.checkType === 'task') {
          if (this.task.bcId !== null && this.task.bcId !== undefined && this.isBcDataSet && bcData) {
            const resTask = await axios.get(process.env.tezosReadApi +
              'contracts/' + process.env.tezosContract + '/bigmaps/tasks/keys/' + this.task.bcId)
            const hash = this.$smartContract.createTaskInfoHash(this.task)
            console.log('taskInfoHash local: ' + hash)
            console.log('taskInfoHash bc: ' + resTask.data.value.infoHash)
            this.isOnBc = resTask.data.value.infoHash === hash
          }
        } else if (this.checkType === 'client') {
          if (this.client.bcId !== null &&
            this.client.bcId !== undefined && this.isBcDataSet && bcData) {
            const resProfile = await axios.get(process.env.tezosReadApi +
              'contracts/' + process.env.tezosContract + '/bigmaps/profiles/keys/' + this.client.bcId)
            const hash = this.$smartContract.createClientInfoHash(this.client)
            console.log('clientInfoHash local: ' + hash)
            console.log('clientInfoHash bc: ' + resProfile.data.value.clientInfoHash)
            this.isOnBc = resProfile.data.value.clientInfoHash === hash
          }
        } else if (this.checkType === 'freelancer') {
          if (this.freelancer.bcId !== null &&
            this.freelancer.bcId !== undefined && this.isBcDataSet && bcData) {
            const resProfile = await axios.get(process.env.tezosReadApi +
              'contracts/' + process.env.tezosContract + '/bigmaps/profiles/keys/' + this.freelancer.bcId)
            const hash = this.$smartContract.createFlancerInfoHash(this.freelancer)
            console.log('freelancerInfoHash local: ' + hash)
            console.log('freelancerInfoHash bc: ' + resProfile.data.value.flancerInfoHash)
            this.isOnBc = resProfile.data.value.flancerInfoHash === hash
          }
        } else if (this.checkType === 'freelancerFeedbacks') {
          if (this.feedback.bcId !== null &&
            this.feedback.bcId !== undefined && this.isBcDataSet && bcData) {
            const resFeedback = await axios.get(process.env.tezosReadApi +
              'contracts/' + process.env.tezosContract + '/bigmaps/feedbacks/keys/' + this.feedback.bcId)
            console.log('local score: ' + this.feedback.clientRate)
            console.log('bc score: ' + resFeedback.data.value.flancersScore)
            this.isOnBc = resFeedback.data.value.flancersScore === this.feedback.clientRate
          }
        } else if (this.checkType === 'clientFeedbacks') {
          if (this.feedback.bcId !== null &&
            this.feedback.bcId !== undefined && this.isBcDataSet && bcData) {
            const resFeedback = await axios.get(process.env.tezosReadApi +
              'contracts/' + process.env.tezosContract + '/bigmaps/feedbacks/keys/' + this.feedback.bcId)
            console.log('local score: ' + this.feedback.freelancerRate)
            console.log('bc score: ' + resFeedback.data.value.clientsScore)
            this.isOnBc = resFeedback.data.value.clientsScore === this.feedback.freelancerRate
          }
        } else {
          console.log('BC check type not found!')
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
